import { CheckIfPlanStatusSyncedWorkflowsApp } from "../CheckIfPlanStatusSyncedWorkflowsApp";
import { useUpgradePlanContext } from "../UpgradePlanContext";

export const WorkflowAppSyncingRoute = () => {
  const { plan } = useUpgradePlanContext();

  return <CheckIfPlanStatusSyncedWorkflowsApp planTier={plan?.tier} />;
};
